import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import WaitingPaxPrimeMessage from "~/components/engage/Waitings/WaitingPaxPrimeMessage";
import withPrimeContext from "../withPrimeContext";

export default withPrimeContext(
  withErrorBoundary(WaitingPaxPrimeMessage, { name: "WaitingPaxPrimeMessage" }),
);
